import React from 'react'

import priceParser from 'utils/priceParser'

const tmpPrice = 4242.42

const TotalPrice = ({t}) => (
  <div className='totalPrice'>
    <div>
      <p>{t('Subtotal')}</p>
      <p>{priceParser(tmpPrice)}</p>
    </div>
    <div>
      <p>{t('Delivery')}</p>
      <p>{priceParser(tmpPrice)}</p>
    </div>
    <div>
      <p>{t('VAT (10%)')}</p>
      <p>{priceParser(tmpPrice)}</p>
    </div>
    <div>
      <p>{t('Total price')}</p>
      <p>{priceParser(tmpPrice)}</p>
    </div>
  </div>
)

export default TotalPrice
